import { connect } from "react-redux"
import { compose } from "redux"
import StatisticsPageDrivers from "../components/statistics-page-drivers"
import { getVariables } from "../utilities/route"
import { withData } from "../decorators/with-data"
import gql from "graphql-tag"
import { withTranslations } from "../decorators/with-translations"
import {
  setSubmitError,
  setDriversViewMode,
  setFilters
} from '../actions/survey'
import {
  QUESTIONNAIRE_FRAGMENT,
  SURVEY_LIST_PARAMETER_FRAGMENT,
  SURVEY_TREE_PARAMETER_FRAGMENT
} from "../graphql/fragments"
import { YOU_FILTER, toNormalizedRespondentFilters } from '../utilities/helpers'
import { withImprovementProjectData } from './withImprovementProjectData'

const paramsQuery = gql`
  query FinishPageParams(
    $surveyId: UUID!
    $languageCode: String
  ) {
    questionnaire(languageCode: $languageCode) {
      ...QuestionnaireFragment
    }
    respondentParameters(
      surveyId: $surveyId
      languageCode: $languageCode
    ) {
      ...SurveyListParameter
      ...SurveyTreeParameter
    }
  }
  ${QUESTIONNAIRE_FRAGMENT}
  ${SURVEY_LIST_PARAMETER_FRAGMENT}
  ${SURVEY_TREE_PARAMETER_FRAGMENT}
`;

const query = gql`
  query FinishPageDetails(
    $surveyId: UUID!
    $respondentFilters: [RespondentFilterInput!],
    $languageCode: String
  ) {
    surveyStatistics(
      surveyId: $surveyId
      respondentFilters: $respondentFilters
      languageCode: $languageCode
    ) {
      __typename
      ... on SurveyStatisticsOutput {
        drivers {
          id
          aggregatedResponse
          aggregatedImportance
        }
        questions {
          id
          aggregatedResponse
          aggregatedImportance
          totalRespondentCount
          skippedRespondentCount
        }
      }
    }
  }
`;

const mapStateToProps = ({ survey: { submitError, filters, sortingType, sortAscending, driversViewMode } }) => {
  return {
    submitError,
    filters,
    sortingType,
    sortAscending,
    driversViewMode
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    onSubmitError: (error) => {
      dispatch(setSubmitError(error));
    },
    onSetFilters: filters => {
      dispatch(setFilters(filters))
    },
    onSetDriversViewMode: (viewMode) => {
      dispatch(setDriversViewMode(viewMode));
    }
  };
};

export default compose(
  withTranslations,
  connect(mapStateToProps, mapDispatchToProps),
  withData(paramsQuery, {
    options: (props) => {

      return {
        ...getVariables(props),
        fetchPolicy: "network-only",
      };
    }
  }),
  withData(query, {
    options: (props) => {
      const variables = { ...getVariables(props) }

      if (props.questionnaire.isAfterGameGuest || props.questionnaire.canViewAfterGame) {
        // Aftergame
        props.onSetFilters(props.filters ? props.filters : []);
        console.log(props.filters)
        variables.variables.respondentFilters = toNormalizedRespondentFilters(props.filters);
      } else {
        // Before aftergame always "You" filter
        props.onSetFilters(YOU_FILTER);
        variables.variables.respondentFilters = YOU_FILTER;
      }

      return {
        ...variables,
        fetchPolicy: "network-only",
      };
    },
  }),
  withImprovementProjectData,
)(StatisticsPageDrivers);



// WEBPACK FOOTER //
// ./src/containers/statistics-page-drivers.js